import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hamburger\"><path d=\"M629.504 103.936a14.848 14.848 0 0 1 10.496 5.12 13.568 13.568 0 0 1 2.816 11.264L486.4 908.032a13.568 13.568 0 0 1-13.312 11.008h-82.176a13.056 13.056 0 0 1-10.496-5.12 13.568 13.568 0 0 1-2.816-11.264L535.04 114.944a13.568 13.568 0 0 1 13.312-11.008z m-216.576 81.664a14.08 14.08 0 0 1 9.728 4.096 13.824 13.824 0 0 1 3.84 9.728v2.56l-126.208 597.504a13.056 13.056 0 0 1-11.008 10.496H13.568a14.08 14.08 0 0 1-9.728-4.096 13.824 13.824 0 0 1-3.84-9.472V793.6L126.208 196.352a13.568 13.568 0 0 1 10.752-10.752h275.968z m597.504 0a14.08 14.08 0 0 1 9.728 4.096 13.824 13.824 0 0 1 3.84 9.728v2.56l-126.208 597.504a13.056 13.056 0 0 1-10.752 10.496H611.072a14.08 14.08 0 0 1-9.728-4.096 13.824 13.824 0 0 1-3.84-9.728V793.6l126.208-597.248a13.568 13.568 0 0 1 11.008-10.752h275.712z m0 0\" p-id=\"1286\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hamburger.svg
// module id = PHf5
// module chunks = 42